// baseConfig.ts
import { baseConfigName } from "./baseConfigName.js";
import { Config } from "./config.js";
import { getEnvironment } from "./environment-checks.js";
var baseConfig = new Config(baseConfigName, {
  ROOT_URL: {
    name: "ROOT_URL",
    env: true,
    client: true,
    required: true
  },
  MONGO_URL: {
    name: "MONGO_URL",
    env: true,
    client: false,
    required: true
  },
  SESSION_TIMEOUT_SECS: {
    name: "SESSION_TIMEOUT_SECS",
    env: true,
    client: false,
    required: false,
    parse(value) {
      return parseInt(value);
    },
    defaultVal: 2 * 7 * 24 * 60 * 60
  },
  DEPLOYMENT: {
    name: "DEPLOYMENT",
    env: true,
    client: true,
    required: false,
    defaultVal: "development"
  },
  LOG_LEVEL: {
    name: "LOG_LEVEL",
    env: true,
    client: true,
    required: false,
    defaultVal: "info"
  },
  LISTEN_PORT: {
    name: "LISTEN_PORT",
    env: true,
    client: true,
    required: false,
    parse(value) {
      return parseInt(value);
    },
    defaultVal: 3e3
  },
  NODE_PORT: {
    name: "NODE_PORT",
    env: true,
    client: true,
    required: false,
    parse(value) {
      return parseInt(value);
    },
    defaultVal: 7e3
  },
  ENVIRONMENT: {
    env: false,
    name: "ENVIRONMENT",
    client: true,
    value: getEnvironment()
  },
  DATADIR: {
    env: true,
    name: "DATADIR",
    client: false,
    required: false,
    defaultVal: "/datadir"
  },
  SERVER_SECRET: {
    env: true,
    name: "SERVER_SECRET",
    client: false,
    required: false,
    defaultVal: "supersecret"
  },
  DEFAULT_LANGUAGE: {
    env: true,
    required: false,
    client: true,
    name: "DEFAULT_LANGUAGE",
    defaultVal: "de"
  }
});
export {
  baseConfig
};
